import { Component, Injector, OnInit, ViewChild, AfterViewInit} from '@angular/core';
import { EstudioService} from '../estudio.service';
import { Meta} from '../../../_models/meta';
import { GlmModalService} from '../../../_components/glm-modal/glm-modal.service';
import { CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MetaUnidad} from '../../../_models/meta-unidad';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Observable, of, combineLatest, concat } from 'rxjs';
import { startWith, debounceTime, map } from 'rxjs/operators';

@Component({
    selector: 'meta-list',
    standalone: false,
    templateUrl: 'meta-list.component.html',
    styleUrls: ['meta-list.component.scss'],
    animations: [
        trigger('detailExpand', [
          state('collapsed', style({height: '0px', minHeight: '0'})),
          state('expanded', style({height: '*'})),
          transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
      ],
})

export class MetaListComponent implements OnInit, AfterViewInit {

    metas$: Observable<Meta[]>;
    metasFiltradas$: Observable<MatTableDataSource<Meta>>;
    expandedElement: any | null;
    categorias: any;
    unidadID: number;
    listadoIds: Array<number>;
    guardando = false;

    pendientes = [{value: 'Todos', key: 0},
    {value: 'Con alumnos pendientes', key: 1},
    {value: 'Sin alumnos pendientes', key: 2}];

    // dataSource: MatTableDataSource<Meta>;
    dataSource: Observable<Meta[]>;
    displayedColumns = ['id', 'categoria', 'descripcion', 'alumnos'];

    filterForm = new UntypedFormGroup({
        text: new UntypedFormControl(''),
        categoria: new UntypedFormControl(0),
        pendientes: new UntypedFormControl(0)
    });

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    constructor(private estudioService: EstudioService,
                private modalService: GlmModalService,
                private customAlertService: CustomAlertService,
                private injector: Injector,
                private snackBar: MatSnackBar) {
    }

    ngOnInit() {
        this.categorias = this.injector.get('categorias', [])[0]['categorias'];
        this.categorias.push({
            id: 6,
            nombre: 'Mapa Curricular'
        });
        this.unidadID = this.injector.get('idUnidad', []);
        this.metas$ = of(this.injector.get('listaMetas', [])).pipe(
            map(data => {
                data.forEach(meta => {
                    // Se crea el campo de filtrado por texto para solo realizar esta operación una vez.
                    // TODO: Incluir alumnos
                    const field = meta.categoria.agrupador + ' ' + meta.categoria.nombre + ' ' +
                        meta.htmlEN + '' + meta.htmlFR + '' + meta.htmlES + ' ' + meta.id;
                    meta.filterParam = field.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                });
                return data;
            })
        );
        this.listadoIds = new Array();

        this.metasFiltradas$ = combineLatest([this.filterForm.valueChanges.pipe(
            startWith({text: '', categoria: 0, pendientes: 0})
          ), this.metas$]).pipe(
            debounceTime(200),
            map(([formValues, metas]) => {
              return metas.filter(meta => {
                const text: string = formValues['text'];
                let filterByText = true;
                if (text) {
                  text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').split(' ').forEach(element => {
                    if (!meta['filterParam'].includes(element)) {
                        filterByText = false;
                    }
                  });
                }
                return ((filterByText || formValues['text'] === '')
                &&  (meta.categoriaID === formValues['categoria'] || formValues['categoria'] === 0))
                && (((meta.alumnosPendientes.length > 0) === (formValues['pendientes'] === 1)) || formValues['pendientes'] === 0);
              });
            }),
            map(data => {
                const res = new MatTableDataSource(data);
                res.paginator = this.paginator;
                return res;
            })
          );

    }

    ngAfterViewInit() {
    }

    onSubmit() {
        const requestObject = {idOrigen: +this.unidadID, ids: ''}; // idOrigen -> idUnidad
        requestObject.ids = this.listadoIds.toString();
        this.guardando = true;
        this.estudioService.importarMetas(requestObject).subscribe(res => {
            const lista = this.estudioService.extractData(res);
            this.guardando = false;
            this.snackBar.open(
                `Las metas se han conectado satisfactoriamente con la unidad.`,
                null,
                {duration: 2250});
            lista.map(meta => {
                this.estudioService.agregarElemento(new MetaUnidad(meta));
            });
            this.modalService.cerrarModal();
        }, err => {
            this.guardando = false;
            this.customAlertService.setCustomMessage({
                tipo: 'error',
                texto: `No ha sido posible guardar la meta. <br> Código de error: ${err.statusText}`
            });
        });
    }


    cancelar() {
        this.modalService.cerrarModal();
    }

    checkFiltros(sort) {
    }

    // filtroTexto(filterValue: string) {
    //     filterValue = filterValue.trim();
    //     filterValue = filterValue.toLowerCase();
    //     this.dataSource.filter = filterValue;
    // }

    cambiarEstado(evt, element) {
        if (evt.checked) {
            this.listadoIds.push(element.id);
        } else {
            const index = this.listadoIds.indexOf(element.id);
            if (index > -1) {
                this.listadoIds.splice(index, 1);
            }
        }
        // element.isSelected = evt.checked;
    }
}
